import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { Error } from "../../components/common/Error";
import { ReactComponent as Loader } from "../../assets/loading_icon.svg";
import {
  selectVerifyEmailError,
  selectVerifyEmailErrorKind,
  selectVerifyEmailPending,
  selectVerifyEmailSuccess,
} from "../../store/selectors";
import { UserActionCreator } from "../../store/userActions";
import "./styles.css";

export const getRawQueryParameter = (
  search: string,
  parameterName: string,
): string | null => {
  const query = search.startsWith("?") ? search.slice(1) : search;
  const prefix = `${parameterName}=`;
  const entry = query.split("&").find((part) => part.startsWith(prefix));

  return entry ? entry.slice(prefix.length) : null;
};

export const _VerifyEmail = ({
  pending,
  error,
  errorKind,
  success,
  verifyEmail,
}) => {
  const { id, hash } = useParams();
  const { search } = useLocation();

  const expires = getRawQueryParameter(search, "expires");
  const signature = getRawQueryParameter(search, "signature");
  const hasCompleteLink = Boolean(id && hash && expires && signature);

  const submitVerification = () => {
    if (hasCompleteLink) {
      verifyEmail({ id, hash, expires, signature });
    }
  };

  useEffect(() => {
    if (hasCompleteLink) {
      verifyEmail({ id, hash, expires, signature });
    }
  }, [expires, hasCompleteLink, hash, id, signature, verifyEmail]);

  if (!hasCompleteLink || (error && errorKind === "invalid-link")) {
    return (
      <div className="verify-email_container">
        <Error
          title="Ссылка недействительна"
          description="Ссылка недействительна или срок её действия истёк"
        />
      </div>
    );
  }

  if (pending || (!error && !success)) {
    return (
        <div className="verify-email_container">
          <div className="verify-email_loader">
            <Loader fill="#818C99" stroke="#818C99" width="50%" />
          </div>
          <div className="verify-email_title">Подтверждение e-mail...</div>
        </div>
    );
  }

  if (error) {
    return (
      <div className="verify-email_container">
        <Error
          title="Не удалось подтвердить Email"
          description="Произошла ошибка. Попробуйте ещё раз"
          retryCallback={submitVerification}
          buttonText="Повторить"
        />
      </div>
    );
  }

  return (
      <div className="verify-email_container">
        <div className="verify-email_title">Email успешно подтверждён</div>
        <div className="verify-email_description">
          Теперь вы можете полноценно пользоваться HusamHelper
        </div>
        <a href="/">Продолжить</a>
      </div>
  );
};

const mapStateToProps = (state) => ({
  pending: selectVerifyEmailPending(state),
  error: selectVerifyEmailError(state),
  errorKind: selectVerifyEmailErrorKind(state),
  success: selectVerifyEmailSuccess(state),
});

const mapDispatchToProps = {
  verifyEmail: UserActionCreator.verifyEmail,
};

export const VerifyEmail = connect(
    mapStateToProps,
    mapDispatchToProps,
)(_VerifyEmail);
